module.exports = __webpack_public_path__ + "img/logo.93c37e8e.png";